﻿import { DeferredEvents, EventBus, useEvent } from '../../../contexts/event-bus';
import { useAppSelector } from '../../../hooks/store-hooks';
import { useWorkspaceItemContext } from '../../../contexts/workspace/workspace-item-context';
import { useSafeEffect } from '../../../hooks/use-safe-effect';

// Fires deferred events for currently selectedMap.
export default function MapReadyEventProvider() {
    useEvent('deferred-event-queued', (category: keyof DeferredEvents) => {
        if (category === 'selectedMap') {
            EventBus.fireDeferredEvents('selectedMap');
        }
    });
    const id = useWorkspaceItemContext().id;
    const isFocused = useAppSelector((state) => state.workspace.selectedId === id);

    useSafeEffect(() => {
        if (!isFocused) {
            return;
        }
        EventBus.fireDeferredEvents('selectedMap');
    }, []);

    return null;
}
